<template>
  <!--多选组 值为所有勾选的选项数组-->
  <el-checkbox-group
    id="GjwCheckBoxGroup"
    v-model="value"
    :disabled="config.disabled"
    :style="config.style"
    :class="config.class"
    :min="config.min"
    :max="config.max"
    @change="(val)=>{valChange(val, config)}"
  >
    <el-checkbox
      v-for="opt in config.options"
      :key="opt.value"
      :label="opt.value"
      :disabled="opt.disabled"
    >{{ opt.label }}</el-checkbox>
  </el-checkbox-group>
</template>

<script>
export default {
  name: 'GjwCheckboxGroup',
  props: {
    config: {
      type: Object,
      required: true
    },
    initValue: Array
  },
  data() {
    return {
      value: this.initValue || [],
    }
  },
  methods: {
    valChange(val, item) {
      this.$emit('change', val, item)
    }
  }
}
</script>

<style scoped>

</style>
